<script setup>
import {Modal} from 'ant-design-vue';
import {defineProps, defineEmits, watch, ref} from 'vue';
import convertNumberToCurrency from "@/utils/ConvertNumberToCurrency";
import {formatNewDate} from "@/utils/datetime";

// Nhận props
const props = defineProps({
  visible: Boolean,
  initialData: {
    type: Object,
    default: null
  }
});

const matchData = ref([]);
const classTourStatus = ref("");
const tourStatus = ref("");
const tournament = ref(props.initialData);

// Emit sự kiện
const emit = defineEmits(['update:visible', 'success', 'cancel']);

const handleCancel = () => {
  emit('update:visible', false);
  emit('cancel');
};

const urlServe = process.env.VUE_APP_SERVER_URL

const statusMap = {
  upcoming: {text: "Sắp diễn ra", class: "badge bg-info"},
  ongoing: {text: "Đang diễn ra", class: "badge bg-primary"},
  pending: {text: "Đang diễn ra", class: "badge bg-warning"},
  finished: {text: "Đã kết thúc", class: "badge bg-success"},
  canceled: {text: "Đã huỷ", class: "badge bg-danger"},
};

const statusMatchMap = {
  NOT_SCHEDULED: {class: "badge bg-secondary", text: "Chưa lên lịch"},
  SCHEDULED: {class: "badge bg-info", text: "Đã lên lịch"},
  ONGOING: {class: "badge bg-primary", text: "Đang diễn ra"},
  PAUSED: {class: "badge bg-warning", text: "Tạm hoãn"},
  COMPLETED: {class: "badge bg-success", text: "Đã kết thúc"},
  CANCELED: {class: "badge bg-danger", text: "Đã huỷ"},
};

const convertDate = (isoString) => {
  const date = new Date(isoString);

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

watch(
    () => props.initialData,
    (initData) => {
      if (initData) {
        tournament.value = initData;
        matchData.value = initData.tour_matches;
        tourStatus.value = statusMap[initData?.tour_status]?.text || "Không xác định";
        classTourStatus.value = statusMap[initData?.tour_status]?.class || "";
      } else {
        console.log("no field")
      }
    },
);

</script>

<template>
  <Modal
      :open="props.visible"
      title="Xem thông tin chi tiết giải đấu"
      width="600px"
      okText="Đóng"
      cancelText="Hủy bỏ"
      @cancel="handleCancel"
      @ok="handleCancel"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="master-academy dull-whitesmoke-bg card master-academyview">
          <div class="row d-flex align-items-center justify-content-start">
            <div class="col-12">
              <div class="d-sm-flex justify-content-start align-items-center">
                <a href="javascript:void(0);">
                  <img :alt="tournament?.name" :src="urlServe + tournament?.photo?.url"
                       class="corner-radius-10 w-100" style="max-width: 200px"/>
                </a>
                <div class="info">
                  <h3 class="mb-2 d-flex gap-2">{{ tournament?.name }} <span :class="classTourStatus"
                                                                             class="h4">{{
                      tourStatus
                    }}</span></h3>
                  <div class="profile-set-content w-100 p-0">
                    <ul class="bg-transparent p-0">
                      <li>
                        <img alt="Icon" src="@/assets/img/icons/location.svg"/>
                        <h6>{{ tournament?.contact_address }}</h6>
                      </li>
                      <li>
                        <img alt="Icon" src="@/assets/img/icons/call.svg"/>
                        <h6>{{ tournament?.contact_phone }}</h6>
                      </li>
                    </ul>
                  </div>
                  <div class="coach-profile-set">
                    <ul class="bg-transparent p-0">
                      <li>
                        <div class="coach-profile-set-img">
                          <img alt="Icon" src="@/assets/img/icons/indoor.svg"/>
                        </div>
                        <div class="coach-profile-set-contemt">
                          <h5>Tổng giải thưởng</h5>
                          <span>{{ convertNumberToCurrency.formatMoney(tournament?.award_total ?? 0) }}</span>
                        </div>
                      </li>
                      <li>
                        <div class="coach-profile-set-img">
                          <img alt="Icon" src="@/assets/img/profiles/avatar-01.jpg"/>
                        </div>
                        <div class="coach-profile-set-contemt">
                          <h5>Tổng số VĐV</h5>
                          <span>{{ tournament?.num_player }}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="profile-tab">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button id="tournament_info_tab" aria-selected="true" class="nav-link active"
                      data-bs-target="#tournament_info"
                      data-bs-toggle="tab" role="tab" type="button">
                Thông tin giải đấu
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button id="match_list_tab" aria-selected="false" class="nav-link" data-bs-target="#match_list"
                      data-bs-toggle="tab" role="tab" type="button">
                Danh sách trận đấu
              </button>
            </li>
          </ul>
          <div class="tab-content">
            <div id="tournament_info" class="tab-pane fade show active" role="tabpanel">
              <!-- Accordian Contents -->
              <div class="accordion">
                <div id="info" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-info" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseInfo" aria-expanded="false"
                            class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseInfo" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/lesson-with-me.svg"/></span>
                      Thông tin chung
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseInfo" aria-labelledby="panelsStayOpen-info"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <ul class="amenities-set d-flex flex-column justify-content-start align-items-start">
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày bắt đầu: {{ formatNewDate(tournament?.date_start) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày kết thúc: {{ formatNewDate(tournament?.date_end) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày bắt đầu đăng ký: {{ formatNewDate(tournament?.reg_start_date) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Ngày kết thúc đăng ký: {{ formatNewDate(tournament?.reg_end_date) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Tổng giải thưởng: {{ convertNumberToCurrency.formatMoney(tournament?.award_total ?? 0) }}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i aria-hidden="true" class="fa fa-check-circle text-success me-2"></i>
                            Số lượng người chơi: {{ tournament?.num_player }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div id="description" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-description" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseDescription" aria-expanded="false"
                            class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseDescription" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/Black.svg"/></span>Mô tả
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseDescription" aria-labelledby="panelsStayOpen-description"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <p>{{ tournament?.description ?? '---' }}</p>
                    </div>
                  </div>
                </div>

                <div id="rules" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-rules" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseRules" aria-expanded="false" class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseRules" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/lesson-with-me.svg"/></span>
                      Quy tắc
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseRules" aria-labelledby="panelsStayOpen-rules"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <p>{{ tournament?.rule ?? '---' }}</p>
                    </div>
                  </div>
                </div>

                <div id="courts" class="accordion-item mb-4">
                  <h4 id="panelsStayOpen-courts" class="accordion-header">
                    <button aria-controls="panelsStayOpen-collapseCourts" aria-expanded="false" class="accordion-button"
                            data-bs-target="#panelsStayOpen-collapseCourts" data-bs-toggle="collapse"
                            type="button">
                      <span class="icon-bg"><img alt="Icon" src="@/assets/img/icons/includes1.svg"/></span>
                      Sân thi đấu
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseCourts" aria-labelledby="panelsStayOpen-courts"
                       class="accordion-collapse collapse show">
                    <div class="accordion-body includes-set">
                      <ul v-for="(item, index) in tournament?.arenas" :key="item?.documentId ?? index">
                        <li>
                          <i class="feather-check-square"></i>{{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Accordian Contents -->
            </div>
            <div id="match_list" class="tab-pane fade" role="tabpanel">
              <h5>Tổng số trận: {{ matchData?.length }}</h5>
              <div v-for="(item, index) in matchData" :key="item?.documentId ?? index"
                   class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Chi tiết trận: {{ item?.match_code ?? '---' }}</h4>
                </div>
                <div class="d-flex w-100 ">
                  <ul class="w-100 d-flex justify-content-between align-items-start">
                    <li class="w-25">
                      <h6>Thời gian thi đấu</h6>
                      <p>{{ convertDate(item?.start_date) }}</p>
                    </li>
                    <li class="w-25">
                      <h6>Đội 1</h6>
                      <h5>
                        {{item?.tour_player_team_1?.player_1?.display_name}}
                        <br>
                        {{item?.tour_player_team_1?.player_2?.display_name }}
                      </h5>
                    </li>
                    <li class="w-25">
                      <h6>Kết quả</h6>
                      <h5>
                        <span class="h4">{{ item?.score ? JSON.parse(item.score).join(" - ") : "" }}</span>
                      </h5>
                    </li>
                    <li class="w-25">
                      <h6>Đội 2</h6>
                      <h5>
                        {{ item?.tour_player_team_2?.player_1?.display_name}}
                        <br>
                        {{item?.tour_player_team_2?.player_2?.display_name}}
                      </h5>
                    </li>
                  </ul>
                </div>
                <div class="d-flex w-100 mt-2">
                  <ul class="w-100 d-flex justify-content-between align-items-start">
                    <li class="w-25">
                      <h6>Hạng mục</h6>
                      <p>
                        {{ item?.category?.name }} <br> Vòng đấu: {{ item?.round?.name }}
                      </p>
                    </li>
                    <li class="w-25">
                      <h6>Địa điểm thi đấu</h6>
                      <p>Sân: {{ item?.court?.name }} <br> Nhà thi đấu: {{ item?.court?.arena?.name }}</p>
                    </li>
                    <li class="w-25">
                      <h6>Trọng tài chính</h6>
                      <p>
                        {{ item?.umpire?.name }}
                      </p>
                    </li>
                    <li class="w-25">
                      <h6>Trạng thái</h6>
                      <p><span :class="statusMatchMap[item?.tour_match_status]?.class"> {{
                          statusMatchMap[item?.tour_match_status]?.text
                        }} </span></p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<style scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
